import ChangeOrderBtn from "../ChangeOrderBtn";
import { CircularProgressWithLabel } from "../../../../../../../../components/Loading/CircularProgressWithLabel";
export const taggedDrawingMaterialsCols = [
  {
    accessorKey: "UID",
    header: "UID",
    enableEditing: false,
    grow: false,
    size: 60,
  },
  {
    accessorKey: "tagNumber",
    header: "Tag #",
    enableEditing: false,
    grow: false, //don't allow this column to grow to fill in remaining space
    size: 70,
    Cell: ({ row }) => {
      const m = row.original;
      return m?.tagNumber;
    },
  },
  {
    header: "Description",
    accessorKey: "description",
    enableEditing: false,
    size: 250,
    Cell: ({ row }) => {
      const m = row.original;
      return m.description ? m.description : `${m?.component} ${m?.size}`;
    },
  },
  {
    header: "Dimension",
    accessorKey: "length",
    enableEditing: false,
    size: 20,
  },
  {
    header: "Quantity",
    accessorKey: "quantity",
    enableEditing: false,
    size: 10,

    Cell: ({ row }) => {
      const qty = row.original?.quantity;
      // console.log("rowwwww", row.original);
      function formatNumber(num) {
        return Number.isInteger(num) ? num : num.toFixed(2);
      }

      return formatNumber(Number(qty));
    },
  },
  {
    header: "Unit",
    accessorKey: "unit",
    enableEditing: false,
    size: 20,
    Cell: () => "Nos",
  },
  {
    header: "Progress",
    accessorKey: "progress",
    enableEditing: false,
    size: 20,
    Cell: ({ row }) => {
      let progress = 0;

      const material = row.original;
      const previousDrawingRevisions = material.drawingRevs;

      // Check if material has changed from previous revision
      const isNotInitialRev = !["0", 0, "Rev-A", "A"].includes(
        material.drawing?.revision,
      );

      const previousDrawingRev =
        isNotInitialRev &&
        previousDrawingRevisions?.find(
          (d) => Number(d.revision) === Number(material.drawing?.revision) - 1,
        );

      const previousMaterialRev = previousDrawingRev?.materials?.find(
        (m) => m?.tagNumber === material?.tagNumber,
      );

      let hasChanged = false;
      ["description"].forEach((key) => {
        if (!previousMaterialRev) {
          hasChanged = true;
        }
        if (previousMaterialRev && material[key] !== previousMaterialRev[key]) {
          hasChanged = true;
        }
      });

      // If no change, check progress from previous drawing revision
      if (!hasChanged && previousMaterialRev) {
        const prevHasMrq = previousMaterialRev.mrqMaterials?.[0]?.mrq?.id;
        if (prevHasMrq) progress = 30;

        const prevHasPo = previousMaterialRev.mrqMaterials?.[0]?.poId;
        if (prevHasPo) progress = 60;

        const prevHasMrv = previousMaterialRev.mrvMaterials?.[0];
        if (prevHasMrv) progress = 100;
      } else {
        // Calculate progress from current material
        const hasMrq = material.mrqMaterials?.[0]?.mrq?.id;
        if (hasMrq) progress = 30;

        const hasPo = material.mrqMaterials?.[0]?.poId;
        if (hasPo) progress = 60;

        const hasMrv = material.mrvMaterials?.[0];
        if (hasMrv) progress = 100;
      }

      // console.log("row for progeess", progress);

      return <CircularProgressWithLabel value={progress} />;
    },
  },
  {
    accessorKey: "co",
    header: "Change Order",
    enableEditing: false,
    grow: false,
    size: 10,

    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },

    Cell: ({ row }) => {
      const isNotInitialRev = !["0", 0, "Rev-A", "A"].includes(
        row.original.drawing?.revision,
      );

      const material = row.original;
      const previousDrawingRev =
        isNotInitialRev &&
        row.original.drawingRevs?.find(
          (d) =>
            Number(d.revision) === Number(row.original.drawing?.revision) - 1,
        );

      const previousMaterialRev = previousDrawingRev?.materials?.find(
        (m) => m?.tagNumber === material?.tagNumber,
      );

      let hasChanged = false;

      ["description"].forEach((key) => {
        if (!previousMaterialRev) {
          hasChanged = true;
        }
        if (previousMaterialRev && material[key] !== previousMaterialRev[key]) {
          hasChanged = true;
        }
      });

      // console.log("hasChanged", hasChanged, material?.tagNumber);
      return isNotInitialRev && hasChanged ? (
        <ChangeOrderBtn
          row={row.original}
          previousDrawingRev={previousDrawingRev}
        />
      ) : (
        ""
      );
    },
  },
  // {
  //   header: "Remarks",
  //   accessorKey: "remarks",
  //   enableEditing: false,
  //   size: 150,
  // },
];

export const bulkDrawingMaterialsCols = [
  {
    accessorKey: "item",
    header: "Item",
    enableEditing: false,
    grow: false,
    size: 50,
  },
  {
    accessorKey: "quantity",
    header: "Quantity",
    enableEditing: false,
    grow: false,
    size: 50,
    Cell: ({ row }) => {
      const qty = row.original?.quantity;

      function formatNumber(num) {
        return Number.isInteger(num) ? num : num.toFixed(2);
      }

      return formatNumber(Number(qty));
    },
  },
  // {
  //   accessorKey: 'unit',
  //   header: 'Unit',
  //   enableEditing: false,
  //   grow: false,
  //   size: 50,
  // },
  // {
  //   accessorKey: "materialCode",
  //   header: "Material Code",
  //   enableEditing: false,

  //   size: 120,
  // },
  {
    accessorKey: "description",
    header: "Description",
    enableEditing: false,

    size: 120,
  },
];

export const bulkDescriptionDrawingMaterialsCols = [
  {
    accessorKey: "UID",
    header: "UID",
    enableEditing: false,
    grow: false,
    size: 60,
  },
  // {
  //   accessorKey: "costCode",
  //   header: "Cost Code",
  //   enableEditing: false,
  //   grow: false,
  //   size: 60,
  // },
  // {
  //   accessorKey: "item",
  //   header: "Item",
  //   enableEditing: false,
  //   grow: false,
  //   size: 20,
  // },
  {
    accessorKey: "description",
    header: "Description",
    enableEditing: false,

    size: 180,
  },

  {
    accessorKey: "length",
    header: "Dimension",
    enableEditing: false,
    size: 20,
  },
  {
    accessorKey: "unit",
    header: "Unit",
    enableEditing: false,
    size: 20,
    // Cell: ({ row }) => {
    //   console.log("------------------------ row", row.original);
    //   const isPlate = row.original?.description
    //     ?.toLowerCase()
    //     .includes("plate");
    //   const isPipe = row.original?.description?.toLowerCase().includes("pipe");
    //   const isHead = row.original?.costCode?.toLowerCase().includes("head");
    //   const unit = row.original?.unit;

    //   if (unit) {
    //     return unit;
    //   } else if (isPlate && !isHead) {
    //     return "mm";
    //   } else if (isPipe) {
    //     return "mm";
    //   } else {
    //     return "Nos";
    //   }
    // },
  },

  {
    accessorKey: "quantity",
    header: "Qty",
    enableEditing: false,
    grow: false,
    size: 20,
    Cell: ({ row }) => {
      const qty = row.original?.quantity;

      function formatNumber(num) {
        return Number.isInteger(num) ? num : num.toFixed(2);
      }

      return formatNumber(Number(qty));
    },
  },
  {
    header: "Progress",
    accessorKey: "progress",
    enableEditing: false,
    size: 20,
    Cell: ({ row }) => {
      let progress = 0;

      const material = row.original;
      const previousDrawingRevisions = material.drawingRevs;

      // Check if material has changed from previous revision
      const isNotInitialRev = !["0", 0, "Rev-A", "A"].includes(
        material.drawing?.revision,
      );

      const previousDrawingRev =
        isNotInitialRev &&
        previousDrawingRevisions?.find(
          (d) => Number(d.revision) === Number(material.drawing?.revision) - 1,
        );

      const previousMaterialRev = previousDrawingRev?.materials?.find(
        (m) => m?.tagNumber === material?.tagNumber,
      );

      let hasChanged = false;
      ["description"].forEach((key) => {
        if (!previousMaterialRev) {
          hasChanged = true;
        }
        if (previousMaterialRev && material[key] !== previousMaterialRev[key]) {
          hasChanged = true;
        }
      });

      // If no change, check progress from previous drawing revision
      if (!hasChanged && previousMaterialRev) {
        const prevHasMrq = previousMaterialRev.mrqMaterials?.[0]?.mrq?.id;
        if (prevHasMrq) progress = 30;

        const prevHasPo = previousMaterialRev.mrqMaterials?.[0]?.poId;
        if (prevHasPo) progress = 60;

        const prevHasMrv = previousMaterialRev.mrvMaterials?.[0];
        if (prevHasMrv) progress = 100;
      } else {
        // Calculate progress from current material
        const hasMrq = material.mrqMaterials?.[0]?.mrq?.id;
        if (hasMrq) progress = 30;

        const hasPo = material.mrqMaterials?.[0]?.poId;
        if (hasPo) progress = 60;

        const hasMrv = material.mrvMaterials?.[0];
        if (hasMrv) progress = 100;
      }

      // console.log("row for progeess", progress);

      return <CircularProgressWithLabel value={progress} />;
    },
  },
  {
    accessorKey: "co",
    header: "Change Order",
    enableEditing: false,
    grow: false,
    size: 20,
    Cell: ({ row }) => {
      // console.log("chaaaaaaaaaaange order", row.original.changeOrders);
      const changeOrders = row.original.changeOrders || [];
      return changeOrders.length > 0
        ? changeOrders.map((co) => (
            <ChangeOrderBtn
              key={co.id}
              row={row.original}
              co={co?.changeOrder}
            />
          ))
        : "";
    },
  },
  // {
  //   accessorKey: "weight",
  //   header: "Weight lb",
  //   enableEditing: false,
  //   grow: false,
  //   size: 20,
  //   Cell: ({ row }) => {
  //     const weight = row.original?.weight;

  //     function formatNumber(num) {
  //       return Number.isInteger(num) ? num : num.toFixed(2);
  //     }

  //     return formatNumber(Number(weight));
  //   },
  // },

  // {
  //   accessorKey: "mass",
  //   header: "wt. (kg)",
  //   enableEditing: false,

  //   size: 60,
  // },
  // },
];

export const drawingMaterialsCols = (materials) => {
  const rows = materials || [];

  const isTaggedMaterials =
    rows?.some(
      (row) => row?.tagNumber && String(row.tagNumber).trim() !== "-",
    ) ?? false;

  const cols = isTaggedMaterials
    ? taggedDrawingMaterialsCols
    : bulkDescriptionDrawingMaterialsCols;

  return cols;
};
